export async function compressImage(file, options = {}) {
  const {
    maxWidth = 1600,
    maxHeight = 1600,
    quality = 0.75,
    outputType = 'image/jpeg',
    sizeThreshold = 200 * 1024
  } = options;

  if (!(file instanceof Blob)) return file;
  if (file.size && file.size <= sizeThreshold) return file;

  const img = await loadImageBitmap(file);
  const { width, height } = computeTargetSize(img.width, img.height, maxWidth, maxHeight);

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, width, height);

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('Compression failed'))), outputType, quality);
  });

  const name = typeof file.name === 'string' ? file.name.replace(/\.[^.]+$/, '') : 'upload';
  const ext = outputType === 'image/jpeg' ? 'jpg' : (outputType.split('/')[1] || 'jpg');
  return new File([blob], `${name}.${ext}`, { type: outputType, lastModified: Date.now() });
}

function computeTargetSize(origW, origH, maxW, maxH) {
  if (!origW || !origH) return { width: maxW, height: maxH };
  const ratio = Math.min(maxW / origW, maxH / origH, 1);
  return { width: Math.round(origW * ratio), height: Math.round(origH * ratio) };
}

async function loadImageBitmap(file) {
  if ('createImageBitmap' in window) {
    try {
      return await createImageBitmap(file);
    } catch {}
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });
}
